module.exports = __webpack_public_path__ + "static/media/geesaa_3.63d44d76.PNG";